import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtgPriceListReportComponent } from './atg-price-list-report.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { SpinnerModule } from '@spartacus/storefront';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    I18nModule,
    NgSelectModule,
    SpinnerModule,
    AtgPriceListReportComponent,
    ConfigModule.withConfig({
      cmsComponents: {
        PriceListReportComponent: {
          component: () => import('./atg-price-list-report.component').then((c) => c.AtgPriceListReportComponent),
        },
      },
    } as CmsConfig),
  ],
})
export class AtgPriceListReportModule {}
